"use strict";

var _taggedTemplateLiteral = require("/home/circleci/poc-carditas-app/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

require("core-js/modules/es6.object.define-property");

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n    min-width: 100%;\n    width: 100%;\n  "]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n    &:before {\n      transition: opacity 0.3s ease;\n      transform: translateX(0);\n      opacity: 1;\n    }\n    &:after {\n      animation: ", " 0.5s infinite linear;\n      opacity: 1;\n    }\n  "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n    color: ", ";\n    background-color: ", ";\n    border: 1px solid ", ";\n\n    &:focus,\n    &:hover {\n      color: ", ";\n      background-color: ", ";\n      border-color: ", ";\n    }\n\n    &:disabled {\n      color: ", ";\n      border-color: ", ";\n      background-color: ", ";\n    }\n\n    &:before {\n      background-color: ", ";\n    }\n    &:after {\n      border: solid 2px ", ";\n      border-left-color: ", ";\n    }\n  "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  ", "\n  min-width: 270px;\n  display: inline-block;\n  padding: 12px 16px;\n  color: ", ";\n  cursor: pointer;\n  border: none;\n  border-radius: 8px;\n  position: relative;\n  z-index: 1;\n  overflow: hidden;\n  transition: color 0.3s ease;\n  background-color: ", ";\n\n  &:hover {\n    background-color: ", ";\n  }\n\n  &:disabled {\n    ", ";\n  }\n\n  &:before {\n    left: 0;\n    top: 0;\n    width: 100%;\n    height: 100%;\n    position: absolute;\n    content: '';\n    background-color: #3377bb;\n    transform: translateX(-100%);\n    opacity: 0;\n    transition: opacity 0.3s ease, transform 0.1s 0.3s;\n  }\n\n  &:after {\n    content: '';\n    border: solid 2px #fff;\n    border-left-color: transparent;\n    width: 16px;\n    height: 16px;\n    position: absolute;\n    left: 50%;\n    top: 50%;\n    border-radius: 50%;\n    margin-top: -8px;\n    margin-left: -8px;\n    opacity: 0;\n    transition: opacity 0.2s 0.1s ease;\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    cursor: not-allowed;\n    background-color: ", ";\n    color: ", ";\n  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  from {\n    transform: rotate(0);\n  }\n  to {\n    transform: rotate(359deg);\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buttonFullWidth = exports.buttonIsLoading = exports.buttonSecondary = exports.buttonBase = void 0;

var _stylitas = require("@creditas/stylitas");

var rotation = (0, _stylitas.keyframes)(_templateObject());

var buttonDisabled = function buttonDisabled(_ref) {
  var theme = _ref.theme;
  return (0, _stylitas.css)(_templateObject2(), theme.bColorneutral04, theme.bColorneutral06);
};

var buttonBase = function buttonBase(_ref2) {
  var theme = _ref2.theme;
  return (0, _stylitas.css)(_templateObject3(), _stylitas.utilities.typography.button(theme), theme.bColorneutral01, theme.bColorsecondary05, theme.bColorsecondary06, buttonDisabled({
    theme: theme
  }));
};

exports.buttonBase = buttonBase;

var buttonSecondary = function buttonSecondary(_ref3) {
  var theme = _ref3.theme,
      secondary = _ref3.secondary;
  return secondary && (0, _stylitas.css)(_templateObject4(), theme.bColorsecondary05, theme.bColorneutral01, theme.bColorsecondary05, theme.bColorsecondary05, theme.bColorsecondary01, theme.bColorsecondary06, theme.bColorneutral04, theme.bColorneutral05, theme.bColorneutral01, theme.bColorneutral01, theme.bColorsecondary05, theme.bColorneutral01);
};

exports.buttonSecondary = buttonSecondary;

var buttonIsLoading = function buttonIsLoading(_ref4) {
  var isLoading = _ref4.isLoading;
  return isLoading && (0, _stylitas.css)(_templateObject5(), rotation);
};

exports.buttonIsLoading = buttonIsLoading;

var buttonFullWidth = function buttonFullWidth(_ref5) {
  var fullWidth = _ref5.fullWidth;
  return fullWidth && (0, _stylitas.css)(_templateObject6());
};

exports.buttonFullWidth = buttonFullWidth;